import { apiDate, boolean, optionalString, string, uuid, zenum, zodLess, ZodLessInfer, zrecord } from '@kaiizen/zod-less';

export const ApiFeatureFlagScopeSchema = zenum('global', 'org', 'user');
export type ApiFeatureFlagScope = ZodLessInfer<typeof ApiFeatureFlagScopeSchema>;

export const ApiSetFeatureFlagSchema = zodLess({
  flagName: string,
  enabled: boolean,
  scope: ApiFeatureFlagScopeSchema,
  orgId: optionalString,
  userId: optionalString,
});
export type ApiSetFeatureFlag = ZodLessInfer<typeof ApiSetFeatureFlagSchema>;

export const ApiFeatureFlagsSchema = zrecord(boolean);
export type ApiFeatureFlags = ZodLessInfer<typeof ApiFeatureFlagsSchema>;

export const ApiFeatureFlagRecordSchema = zodLess({
  id: uuid,
  flagName: string,
  enabled: boolean,
  scope: ApiFeatureFlagScopeSchema,
  orgId: optionalString,
  userId: optionalString,
  createdAt: apiDate,
  updatedAt: apiDate,
});
export type ApiFeatureFlagRecord = ZodLessInfer<typeof ApiFeatureFlagRecordSchema>;
export const getFeatureFlagsQueryKey = (userId?: string, orgId?: string) => `feature-flags/${userId ?? 'anonymous'}/${orgId ?? 'no-org'}`;
export const getAllFeatureFlagRecordsQueryKey = () => 'feature-flag-all';
